module.exports = __webpack_public_path__ + "img/collar_edges_length.07268e7b.png";